import axios from 'axios';
import { Config } from './api/axiosCreate';

// setLogSystemError
function setLogSystemError (UserID, Password, PageOrProc, ErrorMsg) {
  const data = {
    UserID: UserID,
    Password: Password,
    PageOrProc: PageOrProc,
    ErrorMsg: ErrorMsg
  }
  return axios.post(Config.baseUrl + 'setLogSystemError', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export {
  setLogSystemError
}
